import { mutationTypes, actionTypes } from '../../../types';
import { logger } from '../../../tools';
/**
 * This method creates the modal navigation button array
 * @param { dispatch, position, length } param0
 */
function createButtonArray({ dispatch, position, length }) {
	return [
		{
			name: position === 0 ? 'close' : 'previous',
			class: '',
			place: 'bottom',
			showIn: '*',
			url: '[function]',
			contentID: position === 0 ? 'skip' : 'previous',
			click: () => {
				dispatch(actionTypes.previous);
			},
		},
		{
			name: position == length - 1 ? 'end' : 'next',
			class: '',
			place: 'bottom',
			showIn: '*',
			url: '[function]',
			contentID: position == length - 1 ? 'end' : 'next',
			click: () => {
				dispatch(actionTypes.next);
			},
		},
	];
}
/**
 * This method resets tutorial and closes conten modal
 * @param { commit, dispatch } store
 */
function closeTutorial({ commit, dispatch }) {
	commit(mutationTypes.tutorialSetPosition, { position: 0 }); // reset tutorial position before close
	commit(mutationTypes.tutorialSet, { tutorialID: null, active: false });
	dispatch(actionTypes.contentModalClose);
}
let isLocalStorageSupported = false;
try {
	isLocalStorageSupported = !!localStorage;
} catch (error) {
	logger.warn(`localStorage is not avilable: ${error}`);
}
export default {
	state: {
		active: false,
		current: null,
		all: {},
		opened:
			isLocalStorageSupported && localStorage && localStorage.opened ? JSON.parse(localStorage.opened) : {},
	},
	mutations: {
		/**
		 * init tutorial state
		 * @param {*} state
		 * @param { exhibitions } all exhibitions of dataSource
		 */
		[mutationTypes.tutorialInit](state, { exhibitions, toursMap }) {
			state.all = exhibitions.reduce((acc, exhibition) => {
				if (exhibition.tutorialTourID && toursMap[exhibition.tutorialTourID]) {
					acc[exhibition.tutorialTourID] = toursMap[exhibition.tutorialTourID];
					acc[exhibition.tutorialTourID].position = 0;
				}
				return acc;
			}, {});
		},
		/**
		 * commit for setting tutorial state
		 * @param {*} state
		 * @param { tutorialID, active } options tutorialID sets current tutorial
		 *
		 */
		[mutationTypes.tutorialSet](state, { tutorialID, active }) {
			logger.log(
				`tutorialSet exhibition: ${
					tutorialID ? state.all[tutorialID].exhibitionID : null
				} tutorial ${tutorialID} set active: ${active}`
			);

			state.active = active;
			state.current = active ? state.all[tutorialID] : null;
			if (active) {
				state.opened[state.current.id] = true;
				if (isLocalStorageSupported && localStorage) localStorage.opened = JSON.stringify(state.opened);
			}
		},
		/**
		 * commit set position of
		 * @param {*} state
		 * @param { position } options  position set position in article array default is 0 (first article)
		 */
		[mutationTypes.tutorialSetPosition](state, { position }) {
			logger.log(`Set Tutorial Position position: ${position}`);
			state.current.position = position ? position : 0;
		},
	},
	plugins: [
		store => {
			/**
			 * Plugin checks if tutorial exists and if it was not opened yet and open it
			 * Loaner devies will always open  tutorial
			 */
			store.subscribe((mutation, state) => {
				if (mutation.type === mutationTypes.setExhibitionID) {
					// check if exhibition has tutorial and if has not opened yet
					const tutorial = Object.values(state.tutorial.all).find(
						tutorial => tutorial.exhibitionID === state.currentExhibitionID
					);
					if (tutorial && (!state.tutorial.opened[tutorial.id] || state.isLoaner)) {
						store.dispatch(actionTypes.tutorialStart, { tutorialID: tutorial.id });
					}
				}
			});
		},
	],
	actions: {
		/**
		 * This action activates the tutorial and opens the contentModal with the first tutorial article
		 * also the navigation modal will be set
		 * @param {*} state
		 * @param { tutorialID } tutorialID of tutorial which to open
		 */
		[actionTypes.tutorialStart]({ state, commit, dispatch }, { tutorialID }) {
			logger.log(
				`Start Tutorial for exhibition: ${state.all[tutorialID].exhibitionID} tutorial ${tutorialID}`
			);
			commit(mutationTypes.tutorialSet, { tutorialID, active: true });

			dispatch(actionTypes.contentModalSet, {
				exhibitionID: state.all[tutorialID].exhibitionID,
				articleID: state.current.exhibitIDs[0].articleID,
				tourID: tutorialID,
				buttons: createButtonArray({ dispatch, position: 0, length: state.current.exhibitIDs.length }),
				close: () => {
					dispatch(actionTypes.end);
				},
			});
		},
		/**
		 * This action loads next tutorial page or closes it when last page was reached
		 * @param {*} store
		 */
		[actionTypes.next]({ state, commit, dispatch }) {
			const newPosition = state.current.position + 1;
			if (newPosition === state.current.exhibitIDs.length) {
				closeTutorial({ commit, dispatch });
			} else {
				commit(mutationTypes.tutorialSetPosition, { position: newPosition });
				dispatch(actionTypes.contentModalSet, {
					exhibitionID: state.current.exhibitionID,
					articleID: state.current.exhibitIDs[newPosition].articleID,
					buttons: createButtonArray({
						dispatch,
						position: newPosition,
						length: state.current.exhibitIDs.length,
					}),
				});
			}
		},
		/**
		 * This action loads previous tutorial page or closes it when last first page was reached
		 * @param {*} store
		 */
		[actionTypes.previous]({ state, commit, dispatch }) {
			const newPosition = state.current.position - 1;
			if (newPosition < 0) {
				closeTutorial({ commit, dispatch });
			} else {
				commit(mutationTypes.tutorialSetPosition, { position: newPosition });
				dispatch(actionTypes.contentModalSet, {
					exhibitionID: state.current.exhibitionID,
					articleID: state.current.exhibitIDs[newPosition].articleID,
					buttons: createButtonArray({
						dispatch,
						position: newPosition,
						length: state.current.exhibitIDs.length,
					}),
				});
			}
		},
		/**
		 * This action ends tutorial and closes content modal
		 * @param {*} store
		 */
		[actionTypes.end]({ commit, dispatch }) {
			closeTutorial({ commit, dispatch });
		},
	},
};
